module.exports = __webpack_public_path__ + "img/index_phone.57a691bf.png";